import React, { Component }from 'react';
import ReactDOM from 'react-dom';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import {SkyLightStateless} from 'react-skylight';
import { Toolbar, Data } from 'react-data-grid-addons';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { DisabledDatePicker } from '../Common/datePicker';
import classNames from 'classnames';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, Table } from 'react-bootstrap';
import Selection from '../Common/selection';
import { Field } from 'redux-form';
import { Link } from 'react-router';
import { InputField } from '../Common/inputField';
import Spinner from '../../components/Widgets/spinner';
import ZoneInformation from '../../containers/Inventories/zoneInformation';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle} from '../Common/style'

let renderDatePicker = props => {
    return (
        <DateTimePicker
            format='YYYY-MM-DD'
            defaultValue={null}
            time={false}
            onChange={(name) => props.input.onChange(name) }
            value={props.input.value || null} />
    )
}

class InboundForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            dirty: false,

            receiveHistories: {
              rows: [],
              selectedRows: null,
              editedRows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null,
              gourpOpen: false
            },

            receiveHistory: {
              rows: [],
              selectedRows: null,
              editedRows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null,
              gourpOpen: false
            },

            newPutAway: {
              rows: [],
              selectedRows: null,
              editedRows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null,
              gourpOpen: false
            },
            showZonesOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
        this.openShowZones = this.openShowZones.bind(this);
        this.closeShowZones = this.closeShowZones.bind(this);
    }

    openShowZones() {
        this.setState({showZonesOpen: true});
    }

    closeShowZones() {
        this.setState({showZonesOpen: false});
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchAllReceiveHistoryDetail();
        this.props.fetchWarehouses();
        this.props.fetchWarehouseDetail(1);
        if(this.props.currentPutAway){
          this.props.fetchPutAwayDetail(this.props.currentPutAway.WarehousePutAway_id);
        }
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once scrapRecords is ready, reset state.

    componentWillReceiveProps(nextProps) {
      if(nextProps.Default_Warehouse_id && nextProps.Default_Warehouse_id != this.props.Default_Warehouse_id) {
        if(nextProps.Default_Warehouse_id.value)
          this.props.fetchWarehouseDetail(nextProps.Default_Warehouse_id.value);
      }
      if(nextProps.binList && nextProps.binList != this.props.binList){
        if(nextProps.binList.error) {
          // var r = confirm(<Translate value="space_not_enough_create_bins" />);
          // if(r == true){
          //   this.props.createBins(nextProps.binList.Product_id, this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id, nextProps.binList.error, nextProps.binList.BinList);
          // }
          // else {
            var r1 = confirm(<Translate value="space_not_enough_relocate" />);
            if(r1 == true){
              this.props.resetCurrentWarehouseReceive();
              this.props.selectWarehouseReceive(nextProps.binList.Product_id, this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id, nextProps.binList.error, nextProps.binList.BinList);
              this.openShowZones();
            }
          // }
        }
        else {
          let receiveHistory = this.state.newPutAway.rows;
          let selected = Object.assign({}, this.state.receiveHistory.selectedRows[0]);
          let binList = nextProps.binList.BinList;
          let oldBinList = nextProps.binList.OldBinList;
          let totalNum = selected.Quantity;
          let unitPerPallet = selected.UnitPerPallet;
          if(!unitPerPallet)
            unitPerPallet = 0;
          if(binList.length > 0){
            binList.map(bin => {
              bin["isSelected"] = false;
              bin["ProductName"] = selected.ProductName;
              bin["ProductNum"] = nextProps.binList.ProductNum;
              bin["Product_id"] = nextProps.binList.Product_id;
              bin["ProductDescription"] = selected.ProductDescription;
              bin["RcvQuantity"] = nextProps.binList.RcvQuantity;
              bin["BinName"] = bin.Name;
              bin["ZoneName"] = bin.WarehouseZone_id.Name;
              bin["WarehouseZone_id"] = bin.WarehouseZone_id.WarehouseZone_id;
              if(Number(totalNum) < Number(unitPerPallet)){
                bin["PutAwayQuantity"] = (totalNum < 0) ? 0:totalNum;
              }
              else {
                bin["PutAwayQuantity"] = unitPerPallet;
              }
              bin["Pallet"] = 1;
              bin["Quantity"] = selected.Quantity;
              totalNum = Number(totalNum) - Number(unitPerPallet);
              if(this.props.currentPutAway)
                bin["WarehouseReceiveNum"] = this.props.currentPutAway.WarehouseReceiveNum;
            })
          }
          else{
            selected["isSelected"] = false;
            binList.push(selected);
          }
          let newBinList = binList.concat(receiveHistory);
          if(oldBinList){
            oldBinList.map(bin => {
              bin["isSelected"] = false;
              bin["ProductName"] = selected.ProductName;
              bin["ProductDescription"] = selected.ProductDescription;
              bin["ProductNum"] = nextProps.binList.ProductNum;
              bin["Product_id"] = nextProps.binList.Product_id;
              bin["RcvQuantity"] = nextProps.binList.RcvQuantity;
              bin["BinName"] = bin.Name;
              bin["ZoneName"] = bin.WarehouseZone_id.Name;
              bin["WarehouseZone_id"] = bin.WarehouseZone_id.WarehouseZone_id;
              if(Number(totalNum) < Number(unitPerPallet)){
                bin["PutAwayQuantity"] = (totalNum < 0) ? 0:totalNum;
              }
              else {
                bin["PutAwayQuantity"] = unitPerPallet;
              }
              bin["Pallet"] = 1;
              bin["Quantity"] = selected.Quantity;
              totalNum = Number(totalNum) - Number(unitPerPallet);
              if(this.props.currentPutAway)
                bin["WarehouseReceiveNum"] = this.props.currentPutAway.WarehouseReceiveNum || this.props.currentPutAway.WarehouseReceive.WarehouseReceiveNum;
            })
            newBinList = newBinList.concat(oldBinList);
          }
          const newPutAway = {...this.state.newPutAway, rows: newBinList};
          this.setState({newPutAway: newPutAway });
          // this.props.fetchZoneDetail(newBinList[0].WarehouseZone_id);
        }
      }
      if(nextProps.currentPutAwayDetail && nextProps.currentPutAwayDetail != this.props.currentPutAwayDetail){
        let warehouse_PutAway_Line = nextProps.currentPutAwayDetail.Warehouse_PutAway_Line;
        warehouse_PutAway_Line.map(line => {
          line['ZoneName'] = line.WarehouseZone_id.Name;
          line['BinName'] = line.WarehouseBin_id.Name;
          line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
          line['WarehouseBin_id'] = line.WarehouseBin_id.Warehouse_id;
        })
        const newPutAway = {...this.state.newPutAway, rows: warehouse_PutAway_Line}
        this.setState({newPutAway: newPutAway })
      }
      if(nextProps.receiveHistoryDetail && nextProps.receiveHistoryDetail != this.props.receiveHistoryDetail){
        let receiveHistory = Object.assign({}, this.state.receiveHistory);
        if(nextProps.receiveHistoryDetail.Warehouse_Receive_Line){
          let warehouse_Receive_Line = nextProps.receiveHistoryDetail.Warehouse_Receive_Line;
          receiveHistory = {...receiveHistory, rows: warehouse_Receive_Line}
        }
        else{
          receiveHistory = {...receiveHistory, rows: nextProps.receiveHistoryDetail};
        }
        this.setState({receiveHistory: receiveHistory })
      }
        if (nextProps.receiveHistory && nextProps.receiveHistory != this.props.receiveHistory) {
            let receiveHistories = nextProps.receiveHistory;
            receiveHistories.map( receiveHistory => {
                receiveHistory["Vendor"] = receiveHistory.Purchase.Vendor.Name;
                receiveHistory["Purchaser"] = receiveHistory.Purchase.Purchaser.username;
                receiveHistory["FinalPrice"] = receiveHistory.Purchase.FinalPrice;
              }
            )
            const newReceiveHistories = {...this.state.receiveHistories, rows: receiveHistories}
            this.setState({
                receiveHistories: newReceiveHistories
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    // Set scrapRecords being selected to be currentScrapRecord and navigate user to the edit page

    setCurrentPutAway(e) {
        e.preventDefault();
        const currentScrapRecord = this.state.selectedRows[0];
        this.props.selectScrapRecord(currentScrapRecord);
        this.context.router.push('/scrapRecords/'+currentScrapRecord.WarehouseScrapNum);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.fetchReceiveHistoryDetail(this.state.receiveHistories.selectedRows[0].WarehouseReceive_id);
    }

    fetchAllReceiveHistories(e) {
      e.preventDefault();
      this.props.fetchAllReceiveHistoryDetail();
    }

    clickNewPutAway(e) {
      e.preventDefault();
      this.props.fetchBinList(this.state.receiveHistory.selectedRows[0].WarehouseReceiveLine_id);
    }

    zoneDetail(e) {
      e.preventDefault();
      this.props.fetchZoneDetail(this.props.Default_WarehouseZone_id.value);
    }

    renderReceiveHistory() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.receiveHistory);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var receiveHistory = Object.assign({}, this.state.receiveHistory, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({receiveHistory});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.receiveHistory.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const receiveHistory = {...this.state.receiveHistory, filters: newFilters};
                this.setState({ receiveHistory });
            }

            const onRowSelect = rows => {
                const receiveHistory = {...this.state.receiveHistory, selectedRows: rows};
                this.setState({ receiveHistory });
            }

            // Handle the editable function

            // const handleRowUpdated = e => {
            //     // merge updated row with current row and rerender by setting state
            //     let rows = this.state.rows.slice(0);
            //     let editedRows = this.state.editedRows.slice(0);
            //     Object.assign(rows[e.rowIdx], e.updated);
            //     // if the element is already edited, remove the old one.
            //     editedRows.forEach((element, index) => {
            //         if (element.Product_id === rows[e.rowIdx].Product_id)
            //             editedRows.splice(index, 1)
            //     }, this);
            //     // push the row into the editedRows array
            //     editedRows.push(rows[e.rowIdx]);
            //     this.setState({
            //         rows: rows,
            //         editedRows: editedRows
            //     });
            // }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            const columns = [
              {
                  key: 'ProductName',
                  name: <Translate value="product_name" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  locked: true
              },
              {
                  key: 'ProductNum',
                  name: <Translate value="product_num" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'ProductDescription',
                  name: <Translate value="product_description" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'Quantity',
                  name: <Translate value="quantity" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'RcvTotalPrice',
                  name: <Translate value="receive_total_price" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              }
            ]
            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InboundForm-dataGrid1">
                    <ReactDataGrid
                        rowKey='WarehouseReceiveLine_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={this.state.tableHeight}
                        enableRowSelect='single'
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }


    renderNewPutAway() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.newPutAway);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var newPutAway = Object.assign({}, this.state.newPutAway, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState({newPutAway});
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.newPutAway.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                const newPutAway = {...this.state.newPutAway, filters: newFilters};
                this.setState({ newPutAway });
            }

            const onRowSelect = rows => {
                const newPutAway = {...this.state.newPutAway, selectedRows: rows};
                this.setState({ newPutAway });
            }

            const onRowsSelected = (rows) => {
                 let newRows = this.state.newPutAway.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                 });
                 var newPutAway = {...this.state.newPutAway, rows: newRows}
                 this.setState({newPutAway});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = this.state.newPutAway.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 // var rowIndexes = rows.map(r => r.rowIdx);
                 var newPutAway = {...this.state.newPutAway, rows: newRows};
                 this.setState({newPutAway});
             }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = this.state.newPutAway.rows.slice(0);
                let editedRows = this.state.newPutAway.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Product_id === rows[e.rowIdx].Product_id)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                const newPutAway = {...this.state.newPutAway, rows: rows, editedRows: editedRows };
                this.setState({ newPutAway });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            const columns = [
              {
                  key: 'ProductName',
                  name: <Translate value="product_name" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  locked: true
              },
              {
                  key: 'ProductNum',
                  name: <Translate value="product_num" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'ProductDescription',
                  name: <Translate value="product_description" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'Quantity',
                  name: <Translate value="quantity" />,
                  resizable: true,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'ZoneName',
                  name: <Translate value="zone_name" />,
                  resizable: true,
                  sortable: true,
                  editable: true,
                  filterable: true
              },
              {
                  key: 'BinName',
                  name: <Translate value="bin_name" />,
                  resizable: true,
                  sortable: true,
                  editable: true,
                  filterable: true
              },
              {
                  key: 'PutAwayQuantity',
                  name: <Translate value="putaway_quantity" />,
                  resizable: true,
                  sortable: true,
                  editable: true,
                  filterable: true
              }
            ]
            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InboundForm-dataGrid2">
                    <ReactDataGrid
                        rowKey='WarehouseReceiveLine_id'
                        enableCellSelect={true}
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={this.state.tableHeight}
                        enableRowSelect='single'
                        onRowUpdated={handleRowUpdated}
                        rowSelection={{
                          showCheckbox: true,
                          enableShiftSelect: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                           isSelectedKey: 'isSelected'
                          }
                       }}
                        />
                </div></Col></Row>
            )
        }
    }

    renderProducts(bin) {
      let products = bin.Product;
      if(products) {
        return products.map(product => {
          return (
            <Row className="marginTopStyle"><Col sm={ 12 }> { product.Name } </Col></Row>
          )
        })
      }
    }

    renderBins() {
        const { currentZoneDetail, bins, detailError, detailIsLoading } = this.props;
        if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle" />
        else if (detailError) return <div className="alert alert-danger">{JSON.stringify(this.props.detailError) }</div>
        if (bins) {
            return bins.map((bin) => {
                const { Name, Description, WarehouseBin_id } = bin;
                return (
                    <Col sm={ 12 }>
                        <Panel>
                            <Row>
                                <Col sm={ 12 }>
                                  <Row><Col sm={ 12 }>
                                        <em className="fa fa-institution marginRightStyle" />
                                        <b><Translate value="bin" /> {Name || 'Name'}</b>
                                  </Col></Row>
                                  <Row><Col sm={ 12 }>
                                        <em className="fa fa-institution marginRightStyle" />
                                        <b><Translate value="id" /> {WarehouseBin_id || 'WarehouseBin_id'}</b>
                                  </Col></Row>
                                    <Row><Col sm={ 12 }>
                                        <em className="fa fa-building marginLeftStyle marginRightStyle"/>
                                        {currentZoneDetail && currentZoneDetail.Name || 'ZoneName'}
                                    </Col></Row>
                                  <Row><label><Translate value="products" />:</label></Row>
                                    {this.renderProducts(bin)}
                                </Col>
                            </Row>
                        </Panel>
                    </Col>
                )
            })
        }
    }


    handleFormSubmit(formProps) {
        this.setState({ dirty: false });
        // if(this.props.currentPutAwayDetail){
        //   let warehousePutAway_id = this.props.currentPutAwayDetail.WarehousePutAway_id
        //   this.props.editPutAway(formProps, this.props.currentPutAwayDetail, this.state.newPutAway.rows, warehousePutAway_id);
        // }
        // else
          this.props.createPutAway( formProps, this.state.receiveHistory.selectedRows[0], this.state.newPutAway.rows);
        // if (!this.props.currentPurchaseTemplate) this.props.createPurchaseTemplate(formProps, Data.Selectors.getRows(this.state));
        // else this.props.editPurchaseTemplate(formProps, Data.Selectors.getRows(this.state));
    }


    deletePutAway(e) {
        e.preventDefault();
        let { newPutAway } = this.state;
        let newPutAwayRows = [...newPutAway.rows ];

        newPutAwayRows = newPutAwayRows.filter(function(obj){
              return obj.isSelected == false || obj.isSelected == null;
            })

        let newNewPutAway = { ...newPutAway, rows: newPutAwayRows};
        this.setState({
            newPutAway: newNewPutAway
        })
    }

        getWarehouseOptions() {
            var warehouseOptions = [];
            this.props.warehouses.map(warehouse => {
                warehouseOptions.push({ value: warehouse.Warehouse_id, label: warehouse.Name })
            });
            return warehouseOptions;
        }

        getZoneOptions() {
          var zoneOptions = [];
          if(this.props.currentWarehouseDetail){
            this.props.currentWarehouseDetail.Warehouse_Zone.map(zone => {
              zoneOptions.push({ value: zone.WarehouseZone_id, label: zone.Name})
            });
          }
          return zoneOptions;
        }

    render() {
        const { handleSubmit, submitting, pristine } = this.props;
        const titleClass = classNames('control-label', 'col-sm-4');
        let createDialogStyle = {
            height: '700px',
            width: '600px',
            marginLeft: '-10%',
        };
        let warehouseOptions = this.getWarehouseOptions();
        let zoneOptions = this.getZoneOptions();
        return (
            <ContentWrapper>
              <div className="content-heading"><Translate value="put_away_form" /></div>
              <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
                <Row><Col sm={ 12 }>
                    <div className="pull-right">
                        <Button className="btn btn-primary marginLeftStyle" >
                            <em className="fa fa-print marginRightStyle" /><Translate value="print" />
                        </Button>
                        <Button
                          className="btn btn-primary marginLeftStyle"
                          type="submit">
                            <em className="fa fa-trash marginRightStyle" /><Translate value="save" />
                        </Button>
                    </div>
                </Col></Row>
                <br/>
                <Col sm={ 9 }>
                  {this.renderReceiveHistory()}
                  <Row>
                    <Button
                      className="btn btn-primary marginLeftStyle"
                      onClick={(e) => this.clickNewPutAway(e) }>
                        <em className="fa fa-plus marginRightStyle" /><Translate value="create_put_away" />
                    </Button>
                    <button
                        className="btn btn-warning"
                        onClick={(e) => this.deletePutAway(e) }
                        ><Translate value="delete" /></button>
                  </Row>
                  {this.renderNewPutAway()}
                </Col>
                <Col sm={ 3 }>
                  <Row>
                    <Col sm={ 6 }>
                      <label><Translate value="create_date" />:<span style={{color: "red"}}>*</span></label>
                      <Field selected={new Date} component={ DisabledDatePicker } name="CreateTime"></Field>
                    </Col>
                    <Col sm={ 6 }>
                      <label><Translate value="update_date" /><span style={{color: "red"}}>*</span></label>
                      <Field selected={new Date} component={ DisabledDatePicker } name="UpdateTime"></Field>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <label><Translate value="msg_select_warehouse" /></label>
                      <Field name="Default_Warehouse_id" component={Selection} options={warehouseOptions}/>
                    </Col>
                    <Col sm={6}>
                      <label><Translate value="msg_select_warehouse_zone" /></label>
                      <Field name="Default_WarehouseZone_id" component={Selection} options={zoneOptions} />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <Button
                        className="btn btn-primary marginLeftStyle"
                        onClick={(e) => this.zoneDetail(e) }>
                          <Translate value="zone_detail" />
                      </Button>
                    </Col>
                  </Row>
                  <Row className="marginTopStyle">
                      <Panel style={{ overflow: "hidden" }}>
                          <Row style={{ overflowY: "scroll", maxHeight: 2*(this.state.tableHeight)}}>
                              { this.renderBins() }
                          </Row>
                      </Panel>
                  </Row>
                </Col>
              </form>
              <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.showZonesOpen} onCloseClicked={() => {
                  this.closeShowZones()
              } } title="choose_a_zone_to_relocate" >
                <ZoneInformation/>
              </SkyLightStateless>
            </ContentWrapper>
        );
    }
}



export default InboundForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inboundForm.jsx